<template>
    <main class="page-home app__main">
        <div class="page-home__container container">
            <div class="row">
                <div class="page-home__hero col-12 col-md-8 order-1">
                    <slot name="hero"></slot>
                </div>

                <div class="page-home__twitter-timeline col-12 col-md-4 order-2 order-md-1">
                    <twitter-card>
                        <slot name="twitter-timeline"></slot>
                    </twitter-card>
                </div>

                <h2 class="page-home__subtitle col-12 order-1">
                    Nos dernières actualités & publications
                </h2>
                <slot name="cards"></slot>
            </div>
        </div>
    </main>
</template>

<script>
    import HeroCard from '@/components/HeroCard';
    import Card from '@/components/Card';
    import TwitterCard from '@/components/TwitterCard';
    import Mantel from '@/components/Mantel';

    export default {
        name: 'PageHome',

        components: {
            HeroCard,
            Card,
            TwitterCard,
            Mantel,
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-home {
        position: relative;

        &__container {
            padding-top: 2rem;

            @include media-breakpoint-down(sm) {
                padding-bottom: 3rem;
            }
        }

        &__hero {
            display: flex;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                height: 43rem;
            }
        }

        &__twitter-timeline {
            display: flex;

            height:  43rem;
        }

        &__title {
            display: none;
        }

        &__subtitle {
            @extend %font-OpenSans-regular;

            display:         flex;
            align-items:     center;
            justify-content: flex-start;

            margin:          0;
            padding-top:     2.4rem;
            padding-bottom:  2.4rem;

            font-size:       3rem;
            line-height:     (36/30);
        }

        &__read-more-link-row {
            display:         flex;
            justify-content: center;

            margin-bottom:   5rem;
        }

        &__column {
            display: flex;
        }
    }
</style>
